"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_2 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_3 = require("@biomemakers/bmk_ui_framework");
const floating_vue_1 = require("floating-vue");
let AreaTabs = class AreaTabs extends vue_property_decorator_1.Vue {
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    shortenExtension(e) {
        if (e.charAt(0) === 'h')
            return 'h';
        return 'ac';
    }
    loadTab(t) {
        this.$emit('loadtab', t);
    }
    beautifyExtension(s) {
        if (s) {
            return (Math.round((parseFloat(s) + Number.EPSILON) * 100) / 100).toString();
        }
        return '-';
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], AreaTabs.prototype, "areas", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], AreaTabs.prototype, "active", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], AreaTabs.prototype, "theme", void 0);
AreaTabs = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TabsSet: bmk_ui_framework_1.TabsSet,
            TabsSetItem: bmk_ui_framework_2.TabsSetItem,
            BecropLogo: bmk_ui_framework_3.BecropLogo,
            Dropdown: floating_vue_1.Dropdown,
            Tooltip: bmk_ui_framework_3.Tooltip,
        },
    })
], AreaTabs);
exports.default = AreaTabs;
